// extracted by mini-css-extract-plugin
export var fileUpload = "_fo-1";
export var modalButton = "_fo-0";